/* Celular do lojista (WhatsApp). Mesma regra do servidor
   (functions/security/confirmacaoTelefone.js → normalizarCelular):
   +55 + DDD + 9 dígitos começando em 9. */
export function normalizarCelularBR(entrada) {
  let d = String(entrada || "").replace(/\D/g, "");
  if (d.length === 13 && d.startsWith("55")) d = d.slice(2);
  if (d.length !== 11) return null;
  const ddd = Number(d.slice(0, 2));
  if (ddd < 11 || ddd > 99 || d[1] === "0" || d[2] !== "9") return null;
  return `+55${d}`;
}

// "+5573999073081" → "(73) 99907-3081"
export function formatarTelefone(telefone) {
  let d = String(telefone || "").replace(/\D/g, "");
  if (d.length === 13 && d.startsWith("55")) d = d.slice(2);
  return d.length === 11 ? `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}` : String(telefone || "");
}

// Conversa no WhatsApp (link oficial wa.me: número internacional, só dígitos)
export const linkWhatsApp = telefone => `https://wa.me/${String(telefone || "").replace(/\D/g, "")}`;
